import React, { useState } from 'react';


export default function NoAccounts(props) {

  let dpLogo = require("images/logos/datapulse-logo-blue-small.png");
  dpLogo = <img className="account-home-logo" src={`/datapulse${dpLogo}`} />

  let chat= require("images/lite/icons/chat.png");
  chat = <img className="filter-grey" src={`/datapulse${chat}`} />

  return (
    <div className="lite-account-home-container">
      <div className="lite-account-home-header">
        <h1>Welcome to {dpLogo}</h1>
        {props.is_owner ? (
          <p className="subheader">Create your first account to get started!</p>
        ) : (
          <p className="subheader">Looks like you don't have access yet!</p>
        )}
      </div>
      <div className="lite-account-home-content">
        <div>{chat}</div>
        {props.is_owner ? (
          <p>Click this <a href="/datapulse/account-management?create_first_account=true">link</a> to create your first account. After that you can configure your dashboards and start pulling data.</p>
        ) : props.is_primary_org ? (
          <p>Reach out to your Digital Position account lead for help. They will be able to grant you the permissions you need to access your accounts.</p>
        ) : (
          <p>Reach out to an admin in your organization for help. They will be able to grant you the permissions you need to access your accounts.</p>
        )}
      </div>
      <div className="lite-account-home-footer">
       <a href="mailto:datapulse@digitalposition.com" >Contact support</a>
      </div>
    </div>
  )
}